export default {
    "sectionsBlockHeaderTemplate": "componentsCompany/global/CardSectionsBlockHeader",
    "sectionsBlockFooterTemplate": "componentsCompany/global/CardSectionsBlockFooter",
    "sections": {
        "library": {
            "showName": "Библиотечные цели",
            "description": "",
            "columnsConfig": "",
            "emptyText": "Нет библиотечных целей",
            "hideOnStagesIfEmpty": [
                "assessment",
                ""
            ],
            "fromLibrary": "library",
            "fieldsAvailableForEdit": {
                "weight": {
                    "stages": [
                        "plan"
                    ]
                },
                "comment.plan": {
                    "stages": [
                        "plan"
                    ],
                    "skipElementEditPermissionsCheck": true
                },
                "comment.assessment": {
                    "stages": [
                        "assessment"
                    ],
                    "skipElementEditPermissionsCheck": true
                }
            }
        },
        "library_manual_fact": {
            "showName": "Библиотечные цели. Ручной факт",
            "emptyText": "Нет библиотечных целей",
            "hideOnStagesIfEmpty": [
                "assessment",
                ""
            ],
            "fromLibrary": "library_manual_fact",
            "fieldsAvailableForEdit": {
                "weight": {
                    "stages": [
                        "plan"
                    ]
                },
                "scale.fact": {
                    "stages": [
                        "assessment"
                    ]
                },
                "comment.plan": {
                    "stages": [
                        "plan"
                    ],
                    "skipElementEditPermissionsCheck": true
                },
                "comment.assessment": {
                    "stages": [
                        "assessment"
                    ],
                    "skipElementEditPermissionsCheck": true
                }
            }
        },
        "manual": {
            "showName": "Личные цели",
            "addElementButtonText": "Создать цель",
            "emptyText": "Нет личных целей",
            "hideOnStagesIfEmpty": [
                "assessment",
                ""
            ],
            "fieldsAvailableForEdit": {
                "name": {
                    "stages": [
                        "plan"
                    ]
                },
                "desc": {
                    "stages": [
                        "plan"
                    ]
                },
                "weight": {
                    "stages": [
                        "plan"
                    ]
                },
                "scale.template_id": {
                    "stages": [
                        "plan"
                    ]
                },
                "scale.scopes": {
                    "stages": [
                        "plan"
                    ]
                },
                "scale.unit_id": {
                    "stages": [
                        "plan"
                    ]
                },
                "scale.plan": {
                    "stages": [
                        "plan"
                    ]
                },
                "scale.fact": {
                    "stages": [
                        "assessment"
                    ]
                },
                "comment.plan": {
                    "stages": [
                        "plan"
                    ],
                    "skipElementEditPermissionsCheck": true
                },
                "comment.assessment": {
                    "stages": [
                        "assessment"
                    ],
                    "skipElementEditPermissionsCheck": true
                }
            }
        },
        "multiplier": {
            "showName": "Коэффициенты",
            "addElementButtonText": "Добавить коэффициент",
            "emptyText": "Нет коэффициентов",
            "multiplyElementsBonus": true,
            "hideOnStagesIfEmpty": [
                "assessment",
                ""
            ],
            "columnsConfig": "multiplier_columns",
            "cardViewConfig": "multiplier_card_view",
            "fromLibrary": "multiplier",
            "fieldsAvailableForEdit": {
                "comment.plan": {
                    "stages": [
                        "plan"
                    ],
                    "skipElementEditPermissionsCheck": true
                },
                "comment.assessment": {
                    "stages": [
                        "assessment"
                    ],
                    "skipElementEditPermissionsCheck": true
                }
            }
        }
    },
    "default_columns": [
        {
            "label": "Название цели",
            "minWidth": 200,
            "template": "components/tableColumnTemplates/card/ElementNameTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged() }"
            }
        },
        {
            "label": "Вес",
            "width": 70,
            "template": "components/tableColumnTemplates/card/ElementWeightTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged(); }"
            }
        },
        {
            "label": "Шкала",
            "width": 340,
            "template": "components/configurableScales/tableColumnTemplates/ElementConfigurableScaleTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged(); }"
            }
        },
        {
            "label": "Единица измерения",
            "width": 90,
            "template": "components/tableColumnTemplates/card/ElementLibraryUnitTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged() }"
            }
        },
        {
            "label": "План",
            "width": 140,
            "template": "components/configurableScales/tableColumnTemplates/ElementConfigurableScalePlanTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged(); }"
            }
        },
        {
            "label": "Комментарий к плану",
            "width": 120,
            "template": "components/tableColumnTemplates/card/ElementCommentsTableColumn",
            "bind": {
                "scope": "scope",
                "stage": "'plan'",
                "last-comment": "scope.row.last_comment_by_stage['plan']",
                "comments-count": "scope.row.comments_count_by_stage['plan']"
            }
        },
        {
            "label": "Факт",
            "width": 240,
            "showOnStages": [
                "assessment"
            ],
            "showOnCompleted": true,
            "template": "components/configurableScales/tableColumnTemplates/ElementConfigurableScaleFactTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged(); }"
            }
        },
        {
            "label": "Комментарий к факту",
            "width": 120,
            "showOnStages": [
                "assessment"
            ],
            "showOnCompleted": true,
            "template": "components/tableColumnTemplates/card/ElementCommentsTableColumn",
            "bind": {
                "scope": "scope",
                "stage": "'assessment'",
                "last-comment": "scope.row.last_comment_by_stage['assessment']",
                "comments-count": "scope.row.comments_count_by_stage['assessment']"
            }
        },
        {
            "label": "% премии",
            "prop": "bonus",
            "showOnStages": [
                "assessment"
            ],
            "showOnCompleted": true,
            "width": 100
        },
        {
            "label": "",
            "template": "components/tableColumnTemplates/card/ElementActionsTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged() }"
            },
            "align": "'center'",
            "width": 72
        }
    ],
    "multiplier_columns": [
        {
            "label": "Название цели",
            "minWidth": 200,
            "template": "components/tableColumnTemplates/card/ElementNameTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged() }"
            }
        },
        {
            "label": "Шкала",
            "width": 340,
            "template": "components/configurableScales/tableColumnTemplates/ElementConfigurableScaleTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged(); }"
            }
        },
        {
            "label": "Единица измерения",
            "width": 90,
            "template": "components/tableColumnTemplates/card/ElementLibraryUnitTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged() }"
            }
        },
        {
            "label": "План",
            "width": 140,
            "template": "components/configurableScales/tableColumnTemplates/ElementConfigurableScalePlanTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged(); }"
            }
        },
        {
            "label": "Комментарий к плану",
            "width": 120,
            "template": "components/tableColumnTemplates/card/ElementCommentsTableColumn",
            "bind": {
                "scope": "scope",
                "stage": "'plan'",
                "last-comment": "scope.row.last_comment_by_stage['plan']",
                "comments-count": "scope.row.comments_count_by_stage['plan']"
            }
        },
        {
            "label": "Факт",
            "width": 240,
            "showOnStages": [
                "assessment"
            ],
            "showOnCompleted": true,
            "template": "components/configurableScales/tableColumnTemplates/ElementConfigurableScaleFactTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged(); }"
            }
        },
        {
            "label": "Комментарий к факту",
            "width": 120,
            "showOnStages": [
                "assessment"
            ],
            "showOnCompleted": true,
            "template": "components/tableColumnTemplates/card/ElementCommentsTableColumn",
            "bind": {
                "scope": "scope",
                "stage": "'assessment'",
                "last-comment": "scope.row.last_comment_by_stage['assessment']",
                "comments-count": "scope.row.comments_count_by_stage['assessment']"
            }
        },
        {
            "label": "% премии",
            "prop": "bonus",
            "showOnStages": [
                "assessment"
            ],
            "showOnCompleted": true,
            "width": 100
        },
        {
            "label": "",
            "template": "components/tableColumnTemplates/card/ElementActionsTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged() }"
            },
            "align": "'center'",
            "width": 72
        }
    ],
    "default_card_view": {
        "header": [
            {
                "label": "План",
                "group": "stats",
                "template": "components/configurableScales/tableColumnTemplates/ElementConfigurableScalePlanTableColumn",
                "bind": {
                    "scope": "scope"
                },
                "on": {
                    "elements-changed": "() => { templateData.elementsChanged(); }"
                }
            },
            {
                "label": "Факт",
                "group": "stats",
                "showOnStages": [
                    "assessment"
                ],
                "showOnCompleted": true,
                "template": "components/configurableScales/tableColumnTemplates/ElementConfigurableScaleFactTableColumn",
                "bind": {
                    "scope": "scope"
                },
                "on": {
                    "elements-changed": "() => { templateData.elementsChanged(); }"
                }
            },
            {
                "label": "Название цели",
                "group": "title",
                "template": "components/tableColumnTemplates/card/ElementNameTableColumn",
                "bind": {
                    "scope": "scope"
                },
                "on": {
                    "elements-changed": "() => { templateData.elementsChanged() }"
                }
            },
            {
                "label": "Процент премии",
                "group": "meta",
                "prop": "bonus",
                "showOnStages": [
                    "assessment"
                ],
                "showOnCompleted": true
            },
            {
                "label": "",
                "group": "actions",
                "template": "components/tableColumnTemplates/card/ElementActionsTableColumn",
                "bind": {
                    "scope": "scope"
                },
                "on": {
                    "elements-changed": "() => { templateData.elementsChanged() }"
                }
            }
        ],
        "body": [
            {
                "label": "Шкала",
                "group": "main",
                "template": "components/configurableScales/tableColumnTemplates/ElementConfigurableScaleTableColumn",
                "bind": {
                    "scope": "scope"
                },
                "on": {
                    "elements-changed": "() => { templateData.elementsChanged(); }"
                }
            },
            {
                "label": "Ед. изм.",
                "group": "main",
                "template": "components/tableColumnTemplates/card/ElementLibraryUnitTableColumn",
                "bind": {
                    "scope": "scope"
                },
                "on": {
                    "elements-changed": "() => { templateData.elementsChanged() }"
                }
            },
            {
                "label": "Вес",
                "group": "main",
                "template": "components/tableColumnTemplates/card/ElementWeightTableColumn",
                "bind": {
                    "scope": "scope"
                },
                "on": {
                    "elements-changed": "() => { templateData.elementsChanged(); }"
                }
            },
            {
                "label": "Комментарий к цели",
                "group": "side",
                "template": "components/tableColumnTemplates/card/ElementCommentsTableColumn",
                "bind": {
                    "scope": "scope",
                    "stage": "'plan'",
                    "last-comment": "scope.row.last_comment_by_stage['plan']",
                    "comments-count": "scope.row.comments_count_by_stage['plan']"
                }
            },
            {
                "label": "Комментарий к факту",
                "group": "side",
                "showOnStages": [
                    "assessment"
                ],
                "showOnCompleted": true,
                "template": "components/tableColumnTemplates/card/ElementCommentsTableColumn",
                "bind": {
                    "scope": "scope",
                    "stage": "'assessment'",
                    "last-comment": "scope.row.last_comment_by_stage['assessment']",
                    "comments-count": "scope.row.comments_count_by_stage['assessment']"
                }
            }
        ]
    },
    "multiplier_card_view": {
        "header": [
            {
                "label": "План",
                "group": "stats",
                "template": "components/configurableScales/tableColumnTemplates/ElementConfigurableScalePlanTableColumn",
                "bind": {
                    "scope": "scope"
                },
                "on": {
                    "elements-changed": "() => { templateData.elementsChanged(); }"
                }
            },
            {
                "label": "Факт",
                "group": "stats",
                "showOnStages": [
                    "assessment"
                ],
                "showOnCompleted": true,
                "template": "components/configurableScales/tableColumnTemplates/ElementConfigurableScaleFactTableColumn",
                "bind": {
                    "scope": "scope"
                },
                "on": {
                    "elements-changed": "() => { templateData.elementsChanged(); }"
                }
            },
            {
                "label": "Название цели",
                "group": "title",
                "template": "components/tableColumnTemplates/card/ElementNameTableColumn",
                "bind": {
                    "scope": "scope"
                },
                "on": {
                    "elements-changed": "() => { templateData.elementsChanged() }"
                }
            },
            {
                "label": "Процент премии",
                "group": "meta",
                "prop": "bonus",
                "showOnStages": [
                    "assessment"
                ],
                "showOnCompleted": true
            },
            {
                "label": "",
                "group": "actions",
                "template": "components/tableColumnTemplates/card/ElementActionsTableColumn",
                "bind": {
                    "scope": "scope"
                },
                "on": {
                    "elements-changed": "() => { templateData.elementsChanged() }"
                }
            }
        ],
        "body": [
            {
                "label": "Шкала",
                "group": "main",
                "template": "components/configurableScales/tableColumnTemplates/ElementConfigurableScaleTableColumn",
                "bind": {
                    "scope": "scope"
                },
                "on": {
                    "elements-changed": "() => { templateData.elementsChanged(); }"
                }
            },
            {
                "label": "Ед. изм.",
                "group": "main",
                "template": "components/tableColumnTemplates/card/ElementLibraryUnitTableColumn",
                "bind": {
                    "scope": "scope"
                },
                "on": {
                    "elements-changed": "() => { templateData.elementsChanged() }"
                }
            },
            {
                "label": "Комментарий к цели",
                "group": "side",
                "template": "components/tableColumnTemplates/card/ElementCommentsTableColumn",
                "bind": {
                    "scope": "scope",
                    "stage": "'plan'",
                    "last-comment": "scope.row.last_comment_by_stage['plan']",
                    "comments-count": "scope.row.comments_count_by_stage['plan']"
                }
            },
            {
                "label": "Комментарий к факту",
                "group": "side",
                "showOnStages": [
                    "assessment"
                ],
                "showOnCompleted": true,
                "template": "components/tableColumnTemplates/card/ElementCommentsTableColumn",
                "bind": {
                    "scope": "scope",
                    "stage": "'assessment'",
                    "last-comment": "scope.row.last_comment_by_stage['assessment']",
                    "comments-count": "scope.row.comments_count_by_stage['assessment']"
                }
            }
        ]
    }
}